import { render, staticRenderFns } from "./CalendarioAnualFormacoes.vue?vue&type=template&id=76675bc2&scoped=true"
import script from "./CalendarioAnualFormacoes.vue?vue&type=script&lang=js"
export * from "./CalendarioAnualFormacoes.vue?vue&type=script&lang=js"
import style0 from "./CalendarioAnualFormacoes.vue?vue&type=style&index=0&id=76675bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76675bc2",
  null
  
)

export default component.exports